module.exports = __webpack_public_path__ + "img/liveABC_logo.94a3b4b1.png";